import { render, staticRenderFns } from "./TServCommodityComp.vue?vue&type=template&id=2d18b75c&scoped=true&"
import script from "./TServCommodityComp.vue?vue&type=script&lang=js&"
export * from "./TServCommodityComp.vue?vue&type=script&lang=js&"
import style0 from "./TServCommodityComp.vue?vue&type=style&index=0&id=2d18b75c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d18b75c",
  null
  
)

export default component.exports